import React, { Component } from 'react';
import './App.css';
import SubmissionForm from "./forms/SubmissionForm";

class Submissions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: 'closed'
		};
	}

	render() {
		const open = this.state.status !== 'closed';

		if (!open) {
			return (
				<div className="nf-page">
					<div className="nf-page-head">
						<p className="nf-eyebrow">Currently closed for submissions</p>
						<h1>Submissions</h1>
					</div>
					<p className="site-text">Check back soon for more information.</p>
				</div>
			);
		}

		return (
			<div className="nf-page">
				<div className="nf-page-head">
					<p className="nf-eyebrow">The home of new voices</p>
					<h1>Your story, part of the global consciousness.</h1>
				</div>

				<p className="site-text" style={{ maxWidth: '62ch' }}>
					Founded in 2020, the mission of Newfangle Press is simple—to encourage and promote new
					talent. Your story should be part of the global consciousness, and the journey to achieve
					that goal should not be daunting.
				</p>

				<div className="nf-two-col">
					<div>
						<p className="site-text">We consider manuscripts which are:</p>
						<ul className="site-text">
							<li>Completed, original, and unpublished or self-published</li>
							<li>Fiction or non-fiction novels or novellas, or graphic novels</li>
						</ul>
						<p className="site-text">
							We do <strong>not</strong> consider:
						</p>
						<ul className="site-text">
							<li>Incomplete manuscripts</li>
							<li>Screenplays or children's books</li>
							<li>Poetry</li>
						</ul>
						<p className="site-text">
							To submit a query for your completed manuscript, fill out the form and attach the
							first five pages as a PDF or DOC file.
						</p>
					</div>
					<div className="nf-surface">
						<SubmissionForm />
					</div>
				</div>
			</div>
		);
	}
}

export default Submissions;
